import { setAccessToken } from 'utils/accessToken';

/**
 * Sets the access token cookie for alta applications.
 *
 * @param token The access token to set
 * @param env Environment for cookie naming (e.g. 'eu', 'dev'). Determines which
 * environment-specific cookie name to use.
 */
export const setAltaCookie = (token?: string | null, env?: OP.Env) => {
  // this will have to change when the url of /signin is moved to new domain
  // though maybe not, now that we use domain for alta.avigilon access token cookie
  // TODO remove this comment after https://openpath.atlassian.net/browse/OPAC-10444
  setAccessToken(token, env);
};
